<div class="top-section">
  <div class="flex items-center">
    <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
      [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
    <h4 class="heading mb-0">{{ ss.t('common_feedback') }}</h4>
  </div>
  <app-svg name="close" role="button" (click)="navigateToToday()"
    [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
</div>
<div class="feedback-form ri-pt-4 ri-px-4">
  <form [formGroup]="feedbackForm" #fbForm="ngForm">
    <app-input-text-editor [control]="getFc('feedbackText')" name="meNoteDescription"
      [placeholder]="ss.t('common_feedbackPlaceholder', { brandName: BRAND_CONFIG.name })" [hideIcon]="true" (focusEvent)="editorFocused.set($event)"
      (formatEvent)="activeFormats.set($event)" (dropdownPositionEvent)="onDropdownPosition($event)"
      [maxLength]="20000"></app-input-text-editor>
  </form>

  <div class="feedback-addons ri-py-4">
    <app-attachment-list class="ri-pt-3" *ngIf="attachmentValues.length > 0" [attachments]="attachmentValues"
      [title]="ss.t('common_feedback')" (deleteEvent)="deleteAttachments($event)"
      [entityName]="'feedback'"></app-attachment-list>
  </div>
</div>
<div class="bottom-section flex items-center justify-between ri-p-4 text-end ri-bt-2">
  <div class="flex items-center">
    <!-- Mobile toolbar (desktop uses floating toolbar inside editor) -->
    <app-text-editor-options *ngIf="cc.isNarrowScreen() && editorFocused()" [activeFormats]="activeFormats()"
      [position]="dropdownPosition()" (closeEvent)="onToolbarClose($event)"
      (editOptionsEvent)="editOptions($event.opt, $event.value)"></app-text-editor-options>
    <div class="flex items-center">
      <app-input-file class="ri-pe-6" [attachments]="newAttachments" [multiple]="true"></app-input-file>
    </div>
  </div>
  <button type="submit" class="btn-text text-16-500 color-35 check-disabled" (click)="save()" [disabled]="!isValid()">{{
    ss.t('common_submit') }}</button>
</div>
<div id="konva-container" class="hidden" style="background-color: #231a1a; border-radius: 16px; padding: 32px;"></div>